import { compose, map, pathOr } from 'ramda'

export const selectCustomFields = compose(
  map((item) => ({
    ...item,
    id: item.id.toString(),
  })),
  pathOr([], ['customFields', 'data']),
)
